<template>
  <v-row>
    <v-col>
      <MedicineList />
    </v-col>
  </v-row>
</template>

<script>
  import MedicineList from "@/components/config/medicine/medicine/list.vue";

  export default {
    name: "MedicineConfig",
    components: {
      MedicineList,
    },
  };
</script>

<style lang="scss" scoped></style>
